// SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>
//
// SPDX-License-Identifier: MPL-2.0

const CHARS_PER_TOKEN = 4;
const TOKENS_PER_WORD = 2;

function normalizeText(text) {
  if (typeof text === 'string') {
    return text;
  }
  if (text === null || text === undefined) {
    return '';
  }
  return String(text);
}

function estimateTokens(text) {
  const normalized = normalizeText(text);
  const charEstimate = Math.ceil(normalized.length / CHARS_PER_TOKEN);
  const words = normalized.trim().length === 0 ? 0 : normalized.trim().split(/\s+/u).length;
  const wordEstimate = Math.ceil(words * TOKENS_PER_WORD);

  return Math.max(charEstimate, wordEstimate);
}

function estimateMessageListTokens(messages) {
  if (!Array.isArray(messages)) {
    return 0;
  }

  return messages.reduce((sum, message) => sum + estimateTokens(message?.content || ''), 0);
}

export { estimateMessageListTokens, estimateTokens };
